import axios from 'axios';

const defaultURL = 'https://192.168.1.10:8205';
const storageKey = 'cdrfiles_server_url';

const GetCdrfilesServerURL = () => { 
  var url = localStorage.getItem(storageKey);
  if (!url) {
    url = defaultURL
    localStorage.setItem(storageKey, url);
  }
  return url;
}

const cdrFilesService = axios.create({
  baseURL: GetCdrfilesServerURL() + '/api', // Замените на ваш API URL ... baseURL: 'https://localhost:44377/api',
});

cdrFilesService.getCdrfilePreview = (imageId) => {
  return GetCdrfilesServerURL() + `/pngfiles/${imageId}.png`
}

// Interceptor для добавления токена в заголовки
cdrFilesService.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor для отлова 401 ошибки
cdrFilesService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default cdrFilesService;